module.exports = __webpack_public_path__ + "static/media/tag.28277dfa.svg";